import { render } from "./DesignStudioModal.vue?vue&type=template&id=55fa9fdc"
import script from "./DesignStudioModal.vue?vue&type=script&lang=js"
export * from "./DesignStudioModal.vue?vue&type=script&lang=js"

import "./DesignStudioModal.vue?vue&type=style&index=0&id=55fa9fdc&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__